import { useCallback } from 'react';

export const DEFAULT_CHUNK_SIZE = 10;

const useBatchProcessing = (chunkSize: number = DEFAULT_CHUNK_SIZE) => {
  const processBatches = useCallback(
    async <T>(items: T[], processor: (chunk: T[], processed: number) => Promise<unknown>): Promise<void> => {
      if (items.length === 0) return;

      const chunks: T[][] = [];
      for (let i = 0; i < items.length; i += chunkSize) {
        chunks.push(items.slice(i, i + chunkSize));
      }
      try {
        let processed = 0;

        for (const chunk of chunks) {
          await processor(chunk, processed);
          processed += chunk.length;
        }
      } catch (error) {
        console.error('Error processing batches:', error);
        throw error;
      }
    },
    [chunkSize],
  );

  const createChunks = useCallback(
    <T>(items: T[]): T[][] => {
      const chunks: T[][] = [];
      for (let i = 0; i < items.length; i += chunkSize) {
        chunks.push(items.slice(i, i + chunkSize));
      }

      return chunks;
    },
    [chunkSize],
  );

  return {
    processBatches,
    createChunks,
  };
};

export default useBatchProcessing;
